export const isNumber = (value: unknown): value is number => {
  const V = Number(value);
  return typeof V === "number" && !isNaN(V);
};
export const isPlainObject = (obj: unknown): obj is Record<string, unknown> => {
  return Object.prototype.toString.call(obj) === "[object Object]";
};

export const hasKey = <T extends object>(key: unknown, obj: T): key is keyof T => {
  if ((typeof key !== "string" && typeof key !== "symbol") || !isPlainObject(obj)) {
    return false;
  }
  return key in obj;
};
export const isIndex = () => {
  const PATH = window.location.pathname;
  const flag = /index.html$/g.test(PATH) || PATH == "/";
  return flag;
};
